export const CCSTORE = {
  UPDATE_CALC_CACHE: 'calcCache/UPDATE_CALC_CACHE',
  CLEAR_CACHE: 'calcCache/CLEAR_CACHE',
} as const;
